
<template>
  <div>
    <v-row class="px-3 pb-2 pt-1 mb-2">
      <v-expansion-panels multiple>
        <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple v-for="(company, name) in val.companies" :key="name + Math.random()">
          <v-spacer></v-spacer>
          <v-expansion-panel-header class="red--text font-weight-bold">
            {{ name }}
            <span v-for="comp in keys.comp" :key="comp + 'comp'" class="mx-2">
              <b>{{ key_map[comp] }}:</b>
              <span v-if="comp == 'sum'">
                {{ Number(company[comp]).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
              </span>
              <span v-if="comp != 'sum'">
                {{ company[comp] }}
              </span>
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-container grid-list-xl class="py-2">
              <div class="title">Itens</div>
              <items-extract :items="company.items" :kind='kind'></items-extract>
            </v-container>

          </v-expansion-panel-content>
        </v-expansion-panel>

      </v-expansion-panels>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import data_extract_mixin from '../data_extract_mixin'
import ItemsExtract from './ItemsExtract.vue'

export default {
  components: { ItemsExtract },
  name: 'CompanyExtract',
  props: {
    val: {
      type: Object,
    },
    kind: {
      type: String
    }
  },
  mixins: [data_extract_mixin],
}
</script>